import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'
import { useEffect } from 'react'

const ResultsDrivenModal = () => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src =
            'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
        script.async = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title="Book a Coaching Call" />
                <ModalContent>
                    <div
                        className="meetings-iframe-container h-full"
                        data-src="https://meetings.hubspot.com/kaylabragg/results-driven-member-coaching-call?embed=true"></div>
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}

export default ResultsDrivenModal
